var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecorded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0395 9.45333C37.1808 7.28842 31.7525 6.7521 26.5641 7.92435C21.3757 9.0966 16.7052 11.9146 13.2493 15.9581C9.79328 20.0016 7.73695 25.0539 7.38697 30.3616C7.03698 35.6692 8.41209 40.9478 11.3072 45.4101C14.2023 49.8724 18.4623 53.2793 23.4519 55.1226C28.4414 56.966 33.8932 57.1471 38.994 55.6389C44.0949 54.1308 48.5716 51.0141 51.7565 46.7538C54.9414 42.4935 56.6638 37.3178 56.6668 31.9987V29.5465C56.6668 28.4419 57.5623 27.5465 58.6668 27.5465C59.7714 27.5465 60.6668 28.4419 60.6668 29.5465V31.9998C60.6633 38.1815 58.6616 44.1977 54.9603 49.1488C51.2589 54.1 46.0562 57.7221 40.1282 59.4748C34.2001 61.2275 27.8643 61.0171 22.0656 58.8748C16.267 56.7324 11.3162 52.7731 7.95158 47.5872C4.58699 42.4013 2.9889 36.2667 3.39564 30.0984C3.80237 23.93 6.19216 18.0584 10.2086 13.3592C14.225 8.66003 19.6528 5.38504 25.6826 4.0227C31.7123 2.66035 38.0209 3.28365 43.6675 5.79961C44.6765 6.24917 45.1299 7.43153 44.6804 8.44047C44.2308 9.44942 43.0485 9.90289 42.0395 9.45333Z",
    fill: "#04C57E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0802 9.25158C60.8616 10.0322 60.8622 11.2986 60.0816 12.08L33.4149 38.7733C33.0399 39.1487 32.5311 39.3597 32.0005 39.3598C31.4699 39.36 30.961 39.1492 30.5858 38.774L22.5858 30.7741C21.8047 29.993 21.8047 28.7267 22.5858 27.9456C23.3668 27.1646 24.6332 27.1646 25.4142 27.9456L31.9993 34.5307L57.2517 9.253C58.0324 8.47156 59.2987 8.47093 60.0802 9.25158Z",
    fill: "#04C57E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecorded);
export default __webpack_public_path__ + "static/media/recorded.0023d77f71af2e0d48faaa9e389a28e3.svg";
export { ForwardRef as ReactComponent };